import { render, staticRenderFns } from "./DaftarKlien.vue?vue&type=template&id=361a9084&"
import script from "./DaftarKlien.vue?vue&type=script&lang=js&"
export * from "./DaftarKlien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports